import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import POUpload from "@/pages/POUpload";
import POList from "@/pages/POList";
import PODetail from "@/pages/PODetail";
import PartCatalog from "@/pages/PartCatalog";
import ShortageReport from "@/pages/ShortageReport";
import BulkDecode from "@/pages/BulkDecode";
import Dispatches from "@/pages/Dispatches";
import TataDispatch from "@/pages/TataDispatch";
import ConsolidatedView from "@/pages/ConsolidatedView";
import Home from "@/pages/public/Home";
import Products from "@/pages/public/Products";
import Industries from "@/pages/public/Industries";
import Services from "@/pages/public/Services";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-slate-500 text-sm" data-testid="auth-loading">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously in URL fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public marketing site */}
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<Products />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="/services" element={<Services />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />

      {/* Staff / internal app */}
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute><POUpload /></ProtectedRoute>} />
      <Route path="/orders" element={<ProtectedRoute><POList /></ProtectedRoute>} />
      <Route path="/all-lines" element={<ProtectedRoute><ConsolidatedView /></ProtectedRoute>} />
      <Route path="/orders/:id" element={<ProtectedRoute><PODetail /></ProtectedRoute>} />
      <Route path="/catalog" element={<ProtectedRoute><PartCatalog /></ProtectedRoute>} />
      <Route path="/bulk-decode" element={<ProtectedRoute><BulkDecode /></ProtectedRoute>} />
      <Route path="/dispatches" element={<ProtectedRoute><Dispatches /></ProtectedRoute>} />
      <Route path="/tata-dispatch" element={<ProtectedRoute><TataDispatch /></ProtectedRoute>} />
      <Route path="/shortage" element={<ProtectedRoute><ShortageReport /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
